<template>
  <div
    :class="`row mt-${top} ml-auto pull-right w-${width}`"
    :style="center ? 'position:absolute; z-index: 1000; margin-left: auto; margin-right: auto; left: 0; right: 0;' : 'position:absolute; right: 25px !important; z-index: 100;'">
    <div class="alert-group" style="width:100%">
      <div v-show="render" :class="classObject" role="alert">
        <button type="button" class="close" data-dismiss="alert" @click="dismissFunction" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <p>{{msg.texto}}</p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    top: { type: Number, default: 0 },
    msg: { type: Object },
    width: { type: String, default: '40' },
    center: { type: Boolean, default: false },
    customClass: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dismissFunction: {
      type: Function,
      default: () => {
        console.log('dismiss alert')
      }
    }
  },

  data () {
    return {
      render: false,
      classMsg: ''
    }
  },

  methods: {
    renderMsg () {
      if (this.msg.texto) {
        this.render = true
      }
    }
  },

  computed: {
    classObject: function () {
      this.renderMsg()
      var obj = {
        ...this.customClass
      }
      obj[`alert alert-${this.msg.type} alert-dismissable`] = true
      return obj
    }
  }
}
</script>
